import React from 'react'
import LearningResourcesFilterProvider from '../../../providers/learning-resources-filter'
import useViewport from '../../../hooks/use-viewport'
import LearningResourcesDesktop from './full'
import LearningResourcesMobile from './compact'

const LearningResourcesManager = () => {
    const { isMobile } = useViewport()
    return (
        <LearningResourcesFilterProvider>
            {!isMobile && <LearningResourcesDesktop />}
            {isMobile && <LearningResourcesMobile />}
        </LearningResourcesFilterProvider>
    )
}

export default LearningResourcesManager